import EmptyState from "../../assets/images/EmptyStates.svg";

// Empty state component for reusability
const EmptyStateComponent = ({
  title,
  description,
  buttonText,
  buttonAction,
  image = EmptyState,
  titleClass = "w-[248px] mx-auto my-[8px] text-[24px] font-[700] leading-[22px]",
}) => (
  <div className="items-center text-center w-full h-full">
    <div className="mx-auto mt-[84px] justify-center flex text-center">
      <img src={image} alt="empty state" />
    </div>
    <div className="text-center">
      <h4 className={titleClass}>{title}</h4>
      {description && (
        <p className="w-full md:w-[342px] mb-[8px] mx-auto text-[14px] font-[400] leading-[20px]">
          {description}
        </p>
      )}
      {buttonText && (
        <button
          onClick={buttonAction}
          className="bg-[#20232df0] text-white rounded-[999px] p-[10px] text-[14px] w-[152px] min-w-fit px-4"
        >
          {buttonText}
        </button>
      )}
    </div>
  </div>
);

export default EmptyStateComponent;
